<template>
    <div>
      <Header />
      <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
        <v-row no-gutters>
          <v-col cols="12" sm="12" style="text-align:center">
            <img  :src="require('@/assets/images/loader.svg')"  />
          </v-col>
        </v-row>
      </v-dialog>
      <v-snackbar Bottom :timeout="timeout" color="green"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
        fixed
      >
        <v-tab>
          <v-icon style="color: blue">mdi-cloud-upload</v-icon
          ><b style="padding-left: 5px"> Not Uploaded</b>
        </v-tab>
        <v-tab>
          <v-icon style="color: green">mdi-cloud-check</v-icon
          ><b style="padding-left: 5px">Uploaded </b>
        </v-tab>
      </v-tabs>
  
      <v-tabs-items v-model="tab">
        <v-tab-item style="max-height: 84vh; overflow: auto">
    
          <v-expansion-panels focusable  style="border-radius:0px !important;padding-top: 0px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-left: 5px;margin-top: 5px;">
    <v-expansion-panel
     v-for="(item, i) in this.VoucherRegister" :key="i"
       style="  margin-bottom:3px !important;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius:8px;"
    >
      <v-expansion-panel-header style="padding-right:8px !important;padding-left:10px !important;    padding-top: 10px;
    padding-bottom: 10px;" v-if="((item.UploadStatus === false) && (VoucherType === 'Common' || item.VoucherType === VoucherType ))" >
                <v-row no-gutters style="color: #000">
                  <v-col cols="6"  v-if="item.VoucherNo === ''">
                    <label style="font-weight:100" v-if="item.VoucherNo === -1 && item.VoucherNo !== '-1'"></label><label style="font-weight: 500 !important;"></label>
                  </v-col>
                    <v-col cols="6"  v-if="item.VoucherNo !== ''">
                    <label style="font-weight:100" v-if="item.VoucherNo !== -1 && item.VoucherNo !== '-1'"># </label><label style="font-weight: 500 !important;">{{item.VoucherNo}}</label>
                  </v-col>
                  <v-col cols="6" style="text-align: right">
                  
                  <v-icon style="font-size: 18px;
    padding-bottom: 3px;padding-right:2px">mdi-calendar </v-icon>
        <label style="font-weight:500">{{FormatDate(item.VoucherDate)}}</label>
                  </v-col>
                  <v-col cols="6" style="text-align: left;padding-top: 5px;">
                  
                  <v-icon style="font-size: 18px;
    padding-bottom: 3px;padding-right:2px">mdi-account </v-icon>
        <label style="font-weight:500">{{item.Title}}</label>
                  </v-col>
                   <v-col cols="6" style="    text-align: right;
    padding-top: 5px;
    color: green;" >
                 
        <label style="font-weight:500">{{item.DisplayVoucherType}}</label>
                  </v-col>
                    <v-col cols="12" style="padding-top: 5px;padding-bottom: 5px;" v-if="item.IsFromVerify === true">
                  <v-divider></v-divider>
                  </v-col>
                    <v-col cols="6" style="text-align: left;padding-top: 5px;" v-if="item.IsFromVerify === true">
                  
                  <v-icon style="font-size: 18px;
    padding-bottom: 3px;padding-right:2px;color: green;">mdi mdi-check-decagram </v-icon>
        <label style="font-weight:500">{{item.DisplayVoucherTypeFrom}}</label>
                  </v-col>
                    <v-col cols="6" style="    text-align: right;
    padding-top: 5px;
    " v-if="item.IsFromVerify === true">
                 
                  <label style="font-weight:100" ># </label><label style="font-weight: 500 !important;" >{{item.ReferNoFrom}}</label>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content v-if="((item.UploadStatus === false) &&(VoucherType === 'Common' || item.VoucherType === VoucherType))">
                <v-row>
                  <v-col cols="12" style="text-align: center">
                    <b style="color: #ff5252">Item Details</b>
                  </v-col>
                </v-row>
                <div
                  v-for="(item1, j) in item.VoucherDetails"
                  :key="j"
                >
                  <v-row style="border-bottom: 1px dotted #000; padding: 10px">
                    <v-col cols="6" style="padding: 1px">
                      {{item1.Barcode}}
                    </v-col>
                    <v-col cols="6" style="padding: 1px; text-align: right">
                   {{ item1.Quantity }}
                    </v-col>
                   
                    <v-col cols="12" style="padding: 1px; text-align: left">
                     {{item1.ItemName}}
                    </v-col>
  
               
                  </v-row>
                </div>
                <div>
                  <v-row class="text-center" style="padding-top: 10px">
                    <v-col cols="12" style="padding-top: 10px">
                      <v-btn color="red" dark @click="DeleteVoucher(i)">
                        <v-icon>mdi-delete</v-icon> </v-btn
                      >&nbsp;
                      <v-btn color="green" dark @click="EditVoucher(i)">
                        <v-icon>mdi-pencil</v-icon> </v-btn
                      >&nbsp;
                      <v-btn color="blue" dark @click="Upload(i,false,true)">
                        <v-icon>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      
        </v-tab-item>
        <v-tab-item style="max-height: 84vh; overflow: auto">
        
              <v-expansion-panels focusable  style="border-radius:0px !important;padding:5px">
    <v-expansion-panel
   v-for="(item, k) in VoucherRegister" :key="k"
       style="  margin-bottom:3px !important;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius:8px;"
    >
      <v-expansion-panel-header style="padding-right:8px !important;padding-left:10px !important;    padding-top: 10px;
    padding-bottom: 10px;"  v-if="item.UploadStatus === true && (VoucherType === 'Common' ||item.VoucherType === VoucherType)">
               <v-row no-gutters style="color: #000">
                  <v-col cols="6"  v-if="item.VoucherNo === ''">
                    <label style="font-weight:100" v-if="item.VoucherNo === -1 && item.VoucherNo !== '-1'"></label><label style="font-weight: 500 !important;"></label>
                  </v-col>
                    <v-col cols="6"  v-if="item.VoucherNo !== ''">
                    <label style="font-weight:100" v-if="item.VoucherNo !== -1 && item.VoucherNo !== '-1'"># </label><label style="font-weight: 500 !important;">{{item.VoucherNo}}</label>
                  </v-col>
                  <v-col cols="6" style="text-align: right">
                  
                  <v-icon style="font-size: 18px;
    padding-bottom: 3px;padding-right:2px">mdi-calendar</v-icon>
        <label style="font-weight:500">{{FormatDate(item.VoucherDate)}}</label>
                  </v-col>
                  <v-col cols="6" style="text-align: left;padding-top: 5px;">
                  
                  <v-icon style="font-size: 18px;
    padding-bottom: 3px;padding-right:2px">mdi-account </v-icon>
        <label style="font-weight:500">{{item.Title}}</label>
                  </v-col>
                    <v-col cols="6" style="    text-align: right;
    padding-top: 5px;
    color: green;">
                 
        <label style="font-weight:500">{{item.DisplayVoucherType}}</label>
                  </v-col>
                  <v-col cols="12" style="padding-top: 5px;padding-bottom: 5px;" v-if="item.IsFromVerify === true">
                  <v-divider></v-divider>
                  </v-col>
                    <v-col cols="6" style="text-align: left;padding-top: 5px;">
                  
                  <v-icon style="font-size: 18px;
    padding-bottom: 3px;padding-right:2px;color: green;" v-if="item.IsFromVerify === true">mdi mdi-check-decagram </v-icon>
        <label style="font-weight:500">{{item.DisplayVoucherTypeFrom}}</label>
                  </v-col>
                    <v-col cols="6" style="    text-align: right;
    padding-top: 5px;
    " v-if="item.IsFromVerify === true">
                 
                  <label style="font-weight:100" ># </label><label style="font-weight: 500 !important;">{{item.ReferNoFrom}}</label>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content v-if="item.UploadStatus === true && item.VoucherType === VoucherType">
                <v-row>
                  <v-col cols="12" style="text-align: center">
                    <b style="color: #ff5252">Item Details</b>
                  </v-col>
                </v-row>
                <div
                  v-for="(item1, l) in item.VoucherDetails"
                  :key="l"
                >
                  <v-row :style="l === item.VoucherDetails.length - 1 ? 'padding: 10px' : 'border-bottom: 1px dotted #000; padding: 10px'">
                    <v-col cols="6" style="padding: 1px">
                      {{item1.Barcode}}
                    </v-col>
                    <v-col cols="6" style="padding: 1px; text-align: right">
                     {{item1.Quantity}}
                    </v-col>
                    <v-col cols="12" style="padding: 1px">
                    {{item1.ItemName}}
                    </v-col>
  
                 
                  </v-row>
                </div>
                <!-- <div>
                  <v-row class="text-center" style="padding-top: 10px">
                    <v-col cols="12" style="padding-top: 10px">
                      <v-btn color="red" dark >
                        <v-icon>mdi-delete</v-icon> </v-btn
                      >&nbsp;
                      <v-btn color="green" dark  hidden>
                        <v-icon>mdi-pencil</v-icon> </v-btn
                      >&nbsp;
                      <v-btn color="blue" dark  hidden>
                        <v-icon>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!--<div  style="padding: 20px; text-align: center">
            <v-img :src="require('@/assets/images/empty.gif')"></v-img>
            <h3>Empty List !</h3>
          </div>-->
        </v-tab-item>
      </v-tabs-items>
  
      <!-- //******************************** */ -->
  
      <!-- //***************************************** */ -->
      <!-- First Tab Bottom Sheet -->
<v-bottom-navigation
  v-if="tab === 0"
  v-model="value"
  grow
  fixed
  bottom
  style="box-shadow: none"
>
  <v-btn value="recent" @click="GoBack">
    <span>Back</span>
    <v-icon>mdi-arrow-left-thick</v-icon>
  </v-btn>

  <v-btn value="favorites" @click="UploadAll()">
    <span>Upload All</span>
    <v-icon>mdi-upload</v-icon>
  </v-btn>
</v-bottom-navigation>

<!-- Second Tab Bottom Sheet -->
<v-bottom-navigation
  v-if="tab === 1"
  v-model="value1"
  grow
  fixed
  bottom
  style="box-shadow: none"
>
  <v-btn value="recent" @click="GoBack">
    <span>Back</span>
    <v-icon>mdi-arrow-left-thick</v-icon>
  </v-btn>

  <v-btn value="favorites" @click="ClearAllConfirmation()">
    <span>Clear All</span>
    <v-icon>mdi-delete</v-icon>
  </v-btn>
</v-bottom-navigation>
     
       
      <v-dialog v-model="DeleteModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Do you want to delete?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="DeleteModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
            @click="ExcecuteDeleteVoucher()"
            style="background-color:#2E7D32;color:#FFF"
          >
            ok
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    
     <v-dialog v-model="ClearAllConfirmationModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Do you want to clear all?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="DeleteModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            No
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
            @click="ClearAll()"
            style="background-color:#2E7D32;color:#FFF"
          >
            Yes
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-menu v-model="GlobalPasswordModal">
     <globalpassword/>
        </v-menu>
    </div>
  </template>
  <script>
  
  import axios from "axios";
  import Header from "../Pages/Header.vue";
  import globalpassword from "../Pages/Globalpassword.vue"
  export default {
    components: {
      Header,globalpassword 
    },
    data() {
      return {
  
        tab: null,
        dlePOS:'',
        snackbar: false,
    SnackbarMessege: '',
    timeout: 2000,
    Loaderdialog:false,
    VoucherRegister:[],
    bURL : localStorage.getItem('BaseURL'),
    Currency:localStorage.getItem('Currency'),
    DecimalPlaces : localStorage.getItem('symbol'),
    DeleteModal:false,
    VoucherDeleteId : -1,
    VoucherType : localStorage.getItem('VoucherType'),
     headers : {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('Token')
              },
     GlobalPasswordModal:false,
     ClearAllConfirmationModal:false
        
      };
    },
    mounted() {
      this.VoucherRegister = localStorage.getItem("VoucherRegister")
      if(this.VoucherRegister !== null)
      {
        this.VoucherRegister = JSON.parse(this.VoucherRegister)
      }
      if(this.VoucherType === null)
      {
        this.VoucherType = "Common"
      }

      for(this.i=0;this.i<this.VoucherRegister.length;this.i++)
      {
        if(this.VoucherRegister[this.i].VoucherType === "DN")
        {
            this.VoucherRegister[this.i].DisplayVoucherType ="Delivery Note"
        }
        if(this.VoucherRegister[this.i].VoucherTypeFrom === "DN")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom ="Delivery Note"
        }
        if(this.VoucherRegister[this.i].VoucherType === "SO")
        {
            this.VoucherRegister[this.i].DisplayVoucherType ="Sales Order"
        }
         if(this.VoucherRegister[this.i].VoucherTypeFrom === "SO")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom ="Sales Order"
        }
        if(this.VoucherRegister[this.i].VoucherType === "PS")
        {
            this.VoucherRegister[this.i].DisplayVoucherType ="Physical Stock"
        }
        if(this.VoucherRegister[this.i].VoucherTypeFrom === "PS")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom ="Physical Stock"
        }
        if(this.VoucherRegister[this.i].VoucherType === "GR")
        {
            this.VoucherRegister[this.i].DisplayVoucherType ="Goods Receipt"
        }
        if(this.VoucherRegister[this.i].VoucherTypeFrom === "GR")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom ="Goods Receipt"
        }
        if(this.VoucherRegister[this.i].VoucherType === "S")
        {
            this.VoucherRegister[this.i].DisplayVoucherType ="Sales"
        }
        if(this.VoucherRegister[this.i].VoucherTypeFrom === "S")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom ="Sales"
        }
        if(this.VoucherRegister[this.i].VoucherType === "P")
        {
            this.VoucherRegister[this.i].DisplayVoucherType = "Purchase"
        }
         if(this.VoucherRegister[this.i].VoucherTypeFrom === "P")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom = "Purchase"
        }
        if(this.VoucherRegister[this.i].VoucherType === "PR")
        {
            this.VoucherRegister[this.i].DisplayVoucherType = "Purchase Return"
        }
        if(this.VoucherRegister[this.i].VoucherTypeFrom === "PR")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom = "Purchase Return"
        }
        if(this.VoucherRegister[this.i].VoucherType === "LPO")
        {
            this.VoucherRegister[this.i].DisplayVoucherType ="LPO"
        }
        if(this.VoucherRegister[this.i].VoucherTypeFrom === "LPO")
        {
            this.VoucherRegister[this.i].DisplayVoucherTypeFrom ="LPO"
        }
      }
    },
    methods: {
    GoBack() {
      localStorage.removeItem('VoucherEditId')
      this.$router.push("Voucher");
    },
    EditVoucher(index)
    {
        if(this.VoucherRegister[index].IsFromVerify === true)
        {
            this.VoucherType = this.VoucherRegister[index].VoucherType
            localStorage.setItem("VoucherType",this.VoucherType)
            localStorage.setItem("VoucherEditId",index)
            this.$router.push("VoucherVerification");
        }
        else{
          this.VoucherType = this.VoucherRegister[index].VoucherType
          localStorage.setItem("VoucherType",this.VoucherType)
          localStorage.setItem("VoucherEditId",index)
          this.$router.push("Voucher");
        }
    },
    Upload(i,IsAll,IsShowSuccess)
    {
      
      this.Obj = this.VoucherRegister[i]
      this.Loaderdialog = true
      console.log(this.bURL + '/api/PDTvoucher')
          axios.post(this.bURL + '/api/PDTvoucher',this.Obj,
          {
                headers: this.headers
          })
          .then((response)  =>  {
            this.VoucherRegister[i].UploadStatus = true
            localStorage.setItem('VoucherRegister',JSON.stringify(this.VoucherRegister))
            if(IsAll === true && IsShowSuccess === false)
            {
              this.UploadAll()
            }
            else{
              this.Loaderdialog = false
              this.SnackbarMessege = "Success"
              this.snackbar = true
            }
          },
           (error)  =>  {
          this.isLoading = false
          this.isSignInDisabled = false
          if(error.response === undefined)
          {
            this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
          }
          else if(error.response.data !=="")
          {
            this.SnackbarMessege = error.response.data
          }
          else if(error.response.status === 401)
          {
             this.GlobalPasswordModal = true
          }
           else{
             this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
           }
          this.snackbar = true
        })
    },
    UploadAll()
    {
        this.IsShowSuccess = false
        for(this.i=0;this.i<this.VoucherRegister.length;this.i++)
        {
          if(this.VoucherRegister[this.i].UploadStatus === false && (this.VoucherRegister[this.i].VoucherType === this.VoucherType || this.VoucherType === 'Common'))
          {
            if(this.i === this.VoucherRegister.length -1)
            {
              this.IsShowSuccess = true
            }
            this.Loaderdialog = true
            this.Upload(this.i,true,this.IsShowSuccess)
          }
        }
        
    },
    DeleteVoucher(index)
    {
        this.VoucherDeleteId = index
        this.DeleteModal = true
    },
    ExcecuteDeleteVoucher()
    {
       this.VoucherRegister.splice(this.VoucherDeleteId,1)
       localStorage.setItem('VoucherRegister',JSON.stringify(this.VoucherRegister))
       this.DeleteModal = false
    },
    ClearAllConfirmation()
    {
        this.ClearAllConfirmationModal = true
    },
    ClearAll()
    {
          for(this.i=this.VoucherRegister.length-1;this.i>-1;this.i--)
          {
               if((this.VoucherRegister[this.i].UploadStatus === true && this.VoucherRegister[this.i].VoucherType === this.VoucherType  ) || (this.VoucherRegister[this.i].UploadStatus === true && this.VoucherType === 'Common'))
               {
                 this.VoucherRegister.splice(this.i,1)
               }
          }
        localStorage.setItem('VoucherRegister',JSON.stringify(this.VoucherRegister))
         this.ClearAllConfirmationModal = false
    },
  FormatDate(Value)
  {
   return  Value.split('T')[0]
  },
  
    }
  };
  </script>
  <style>
   .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
margin-top: -10px;
}
  </style>
  